/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_TitleInputs */

const en_mk_pricing_faq_title = /** @type {(inputs: Mk_Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing questions`)
};

const id_mk_pricing_faq_title = /** @type {(inputs: Mk_Pricing_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertanyaan seputar harga`)
};

/**
* | output |
* | --- |
* | "Pricing questions" |
*
* @param {Mk_Pricing_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_title = /** @type {((inputs?: Mk_Pricing_Faq_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_title(inputs)
	return en_mk_pricing_faq_title(inputs)
});